export enum SCALES {
    default = "default",
    large = "large",
    extraLarge = "extraLarge",
}

export interface IScale {
    size: number;
}

type IScaleList = {
    [key in SCALES]: IScale;
};

export const SCALES_LIST: IScaleList = {
    [SCALES.default]: {
        size: 100,
    },
    [SCALES.large]: {
        size: 150,
    },
    [SCALES.extraLarge]: {
        size: 200,
    },
};
